// Module
var code = "<div ontouchstart=\"var event=arguments[0];event.stopPropagation()\" ontouchend=\"var event=arguments[0];event.stopPropagation()\" class=gz-grid-menu-container></div>";
// Exports
module.exports = code;